// @flow
import { ArrowRight } from 'lucide-react';

import { View } from 'reshaped';

import { Icon, Link } from '@gandi/reshaped';
import { mapTags, useTranslator } from '@gandi/translate';

import { useButtonDisabledReason } from 'src/Layout/components/CartSummary/hooks/useButtonDisabledReason';
import { useCartSummaryContext } from 'src/Layout/context/CartSummary';
import { useAppSelector } from 'src/hooks/useAppSelector';
import { useHasMissingOrgInfo } from 'src/hooks/useMissingOrgInfo';
import { selectShopCurrent } from 'src/modules/organization/selectors';

import { selectHasDomainTransfer } from '../../Setup/modules/selectors';
import { selectCanChangeProductContacts } from '../modules/selectors';

export function ConfigurationButton(): React.MixedElement | null {
  const { __ } = useTranslator();
  const { frozen, productOwnerOrganization, handleConfigurationClick } =
    useCartSummaryContext();

  const currentOrg = useAppSelector(state => selectShopCurrent(state, true));

  const { isDisabled } = useButtonDisabledReason();

  const sharingId = currentOrg?.id;

  const missingCartOwnerInfo = useHasMissingOrgInfo(sharingId);

  const missingProductOwnerInfo = useHasMissingOrgInfo(
    productOwnerOrganization?.id,
    productOwnerOrganization,
  );

  const canChangeProductContacts = useAppSelector(
    selectCanChangeProductContacts,
  );

  const missingInfo = missingCartOwnerInfo || missingProductOwnerInfo;
  const hasDomainTransfer = useAppSelector(selectHasDomainTransfer);

  /** No need to show the button when the Continue button will go there. */
  const driveUserToSetup = missingInfo || hasDomainTransfer;
  const showConfigurationButton = canChangeProductContacts && !driveUserToSetup;

  if (!showConfigurationButton || frozen || isDisabled) return null;

  return (
    <View direction="row" gap={1}>
      {mapTags(
        __(
          'Familiar with technical settings? Access [[link:Advanced configuration]]',
        ),
        ({ link }) => ({
          link: (
            /* eslint-disable jsx-a11y/anchor-is-valid */
            <Link
              attributes={{
                style: {
                  fontWeight: 600,
                },
              }}
              onClick={handleConfigurationClick}
            >
              {link}
            </Link>
            /* eslint-enable jsx-a11y/anchor-is-valid */
          ),
        }),
      )}
      <Icon
        attributes={{
          style: {
            alignSelf: 'end',
          },
        }}
        svg={ArrowRight}
        size={4}
      />
    </View>
  );
}
